import { RadioGroupIndicator, type RadioGroupIndicatorProps } from '@radix-ui/react-radio-group';
import { cn } from '@/shared/lib/cn';
import './radio-group.scss';

export const Indicator = (props: RadioGroupIndicatorProps) => {
    return (
        <RadioGroupIndicator
            forceMount
            {...props}
            className={cn('radio-group__indicator', props.className)}
        />
    );
};

export { Root, Item } from '@radix-ui/react-radio-group';
